<template>
  <div id="chart" v-if="dataObj.labels && dataObj.series">
    <apexchart
      height="350"
      :options="chartOptions"
      :series="dataObj.series"
    ></apexchart>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'apexChartAreaCom',
  props: ['dataObj', 'labelX'],
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      series: [],
      chartOptions: {
        colors: this.dataObj.colors,
        chart: {
          type: 'bar',
          height: 350,
          stacked: true
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '15%',
            endingShape: 'rounded'
          }
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        title: {
          align: 'left'
        },
        subtitle: {
          align: 'left'
        },
        labels: [],
        xaxis: {
          categories: this.dataObj.labels
        },
        yaxis: {
          opposite: true
        },
        fill: {
          opacity: 1
        }
      }
    }
  },
  watch: {
    dataObj: function (val) {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          xaxis: {
            categories: this.dataObj.labels
          }
        }
      }
    }
  }
}
</script>